import * as React from 'react';
import moment from 'moment';
import { Box, Card, CardContent, Grid, LinearProgress } from '@mui/material';
import { useRecordContext, useGetOne, useResourceContext, Link } from 'react-admin';
import LinkIcon from '@mui/icons-material/Link';
import SectionTitle from '../commons/SectionTitle';
import TransformerVaeProtein2LigandOutputShow from '../commons/TransformerVaeProtein2LigandOutputShow';

// Second level rendering
const JobShow = ({ record: _record, resource: _resource, id: _id, ...props }) => {
    const record = _record ?? useRecordContext();
    const resource = _resource ?? useResourceContext();
    const id = _id ?? record?.id;

    let initJob;
    let initJobData;
    if (!record) {
        if (resource && id) {
            initJob = useGetOne( resource, { id });
            if (initJob.isLoading) {
                return null
            }
            if (initJob.error) {
                console.error("Load initJob error");
                return null;
            }
            initJobData = initJob.data;
        } else {
            console.error("No record, need resource && id");
            return null;
        }
    } else {
        initJobData = record;
    }

    let fullJob;
    if (!initJobData.inputData) {
        if (resource && id) {
            fullJob = useGetOne( resource, { id });
        } else {
            console.error("No record.inputData, need resource && id");
            return null;
        }
    } else {
        fullJob = {data: initJobData, isLoading: false, error: false};
    }

    const regexMeta = /^\$.*:/;
    let initJobDataPureName = initJobData.name.replace(regexMeta, '');

    // console.log(record, fullJobData, _resource, useResourceContext())
    return (
        <Card sx={{ margin: 'auto', width: '100%'}} {...props}>
            <CardContent>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <SectionTitle sx={{ fontWeight: 'bold' }} label={
                            (resource && id) ? 
                                <Link sx={{ color: 'black' }} to={`/${resource}/${id}`}>
                                    {initJobDataPureName}
                                    <LinkIcon fontSize='8' sx={{color: 'blue', paddingLeft: 1}}/>
                                </Link> :
                                initJobDataPureName
                        } />
                    </Grid>
                    <Grid item xs={6}>
                        <SectionTitle sx={{textTransform: 'capitalize'}} label={initJobData.status} align='right'/>
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={3}>
                        ID: {initJobData.id}
                    </Grid>
                    <Grid item xs={2}>
                        Queuing: {['running', 'error', 'success'].includes(initJobData.status) ? 
                            (initJobData.distributeTime > 0 && initJobData.queuingTime ? 
                                moment.utc(initJobData.distributeTime - initJobData.queuingTime).format("HH:mm:ss") : '?') :
                            '-'}
                    </Grid>
                    <Grid item xs={2}>
                        Running: {['error', 'success'].includes(initJobData.status) ? 
                            (initJobData.queuingTime > 0 && initJobData.finishTime > 0 ? 
                                moment.utc(initJobData.finishTime - initJobData.queuingTime).format("HH:mm:ss") : '?') :
                            '-'}
                    </Grid>
                </Grid>

                <Box pt="1em" />

                {initJobData.status === "running" && <LinearProgress color='success'/>}
                {initJobData.status === "queued" && <LinearProgress color='secondary'/>}
                {initJobData.status === "hangup" && <LinearProgress color='secondary' variant="determinate" value={0} />}
                {initJobData.status === "success" && <LinearProgress color='success' variant="determinate" value={100} />}
                {initJobData.status === "error" && <LinearProgress color='success' variant="determinate" value={0} />}
                
                <Box pt="1em" />

                {initJobData.status === "success" && 
                    initJobData.workerType === "transformerVaeProtein2Ligand" && 
                    <TransformerVaeProtein2LigandOutputShow {...fullJob}/>
                }
            </CardContent>
        </Card>
    );
};

export default JobShow;
